export default{
    'backHome':'Back to home',
    'liveOver':'The anchor is offline',
    'loginTip': 'Please enter your original password for first login/registration',
    'loginTip2': 'You are not bound to the exhibitor, please contact your company administrator to add you as a sub-account'
}